import { ComponentProps } from "react";

import { cn } from "@bentolabs/kit/utils";

export const Badge = ({ className, ...props }: ComponentProps<"span">) => {
  return (
    <span
      className={cn(
        "flex items-center justify-between rounded-lg bg-current/16 px-2 py-1 text-xs text-current",
        className
      )}
      {...props}
    />
  );
};
